///<reference path="../Core/Frame.js"/>
/**
 * the presence of "prototype" is an indication that the file may benifit
 * from using classes.  This file makes a great candidate for converting to classes
 * and transpiling back down to es3 before any maintenance is done to it.
 */
// TODO: should be turned into a class (ajax and css as instances of sub-classes)
function iQuery() {}
iQuery = iQuery.prototype = {
  // shallow copy from the source to the target if the target is null
  copy: function(source, target) {
    for (var item in source) {
      var src = source[item];
      var copy = target[item];
      if (copy == undefined) {
        target[item] = src;
      }
    }
  },
  // Does a get command
  get: function (url, data, type, success, failed) {
    return iQuery.ajax.invoke({
      type: "GET",
      url: url,
      data: data,
      success: success,
      failed: failed,
      dataType: type
    });
  },
  // does a post command
  post: function (url, data, type, success, failed, serverAsync) {
    return iQuery.ajax.invoke({
      type: "POST",
      url: url,
      data: data,
      success: success,
      failed: failed,
      dataType: type,
      serverAsync: serverAsync
    });
  },
  // deserialzies the JSON string into an object
  deserialize: function(data) {
    if (data.length === 0) throw "CannotDeserializeEmptyString";
    try {
      var exp = data.replace(
        new RegExp('(^|[^\\\\])\\"\\\\/Date\\((-?[0-9]+)\\)\\\\/\\"', "g"),
        "$1new Date($2)"
      );
      return eval("(" + exp + ")");
    } catch (e) {
      throw "Invalid JSON";
    }
  },
  // serializes the object into a JSON string
  serialize: function(object, sort) {
    var builder = "";
    var i;
    switch (typeof object) {
      case "object":
        if (object) {
          if (Array.prototype.isPrototypeOf(object)) {
            builder += "[";
            for (i = 0; i < object.length; ++i) {
              if (i > 0) {
                builder += ",";
              }
              builder += iQuery.serialize(object[i]);
            }
            builder += "]";
          } else {
            if (
              object
                .constructor()
                .toString()
                .match(/date/i)
            ) {
              stringBuilder.append('"\\/Date(');
              stringBuilder.append(object.getTime());
              stringBuilder.append(')\\/"');
              break;
            }
            var properties = [];
            var propertyCount = 0;
            for (var name in object) {
              properties[propertyCount++] = name;
            }
            if (sort) properties.sort();
            builder += "{";
            var needComma = false;
            for (i = 0; i < propertyCount; i++) {
              var value = object[properties[i]];
              if (typeof value !== "undefined" && typeof value !== "function") {
                if (needComma) {
                  builder += ",";
                } else {
                  needComma = true;
                }
                builder += iQuery.serialize(properties[i], sort) + ":";
                builder += iQuery.serialize(value, sort);
              }
            }
            builder += "}";
          }
        } else {
          builder += "null";
        }
        break;
      case "number":
        if (isFinite(object)) {
          builder += String(object);
        } else {
          throw "cannotSerializeNonFiniteNumbers";
        }
        break;
      case "string":
        builder += JSON.stringify(object);
        break;
      case "boolean":
        builder += object.toString();
        break;
      default:
        builder += "null";
        break;
    }
    return builder;
  }
};
iQuery.css = iQuery.prototype = {
  get: function(name, elem, computed, extra) {
    var val;
    if (computed) {
      if (elem.offsetWidth !== 0) {
        val = iQuery.css.getWH(elem, name, extra);
      } else {
        iQuery.css.swap(
          elem,
          (cssShow = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
          }),
          function() {
            val = iQuery.css.getWH(elem, name, extra);
          }
        );
      }
      if (val < 0 || val == null) {
        val = elem.style[name];
        // Should return "auto" instead of 0, use 0 for
        // temporary backwards-compat
        return val === "" || val === "auto" ? 0 : val;
      }
      return typeof val === "string" ? parseFloat(val) : val;
    }
  },
  // A method for quickly swapping in/out CSS properties to get correct calculations
  swap: function(elem, options, callback) {
    var old = {};
    // Remember the old values, and insert the new ones
    for (var name in options) {
      old[name] = elem.style[name];
      elem.style[name] = options[name];
    }
    callback.call(elem);
    // Revert the old values
    for (name in options) {
      elem.style[name] = old[name];
    }
  },
  getWH: function(elem, name, extra) {
    var which = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
    var val =
      name === "width"
        ? Math.max(elem.offsetWidth, elem.clientWidth)
        : Math.max(elem.offsetHeight, elem.clientHeight);
    for (var i in which) {
      val -= parseFloat(elem.style["padding" + which[i]]) || 0;
      val -= parseFloat(elem.style["border" + which[i] + "Width"]) || 0;
    }
    return val;
  }
};
iQuery.ajax = iQuery.prototype = {
  // default ajax settings
  ajaxSettings: {
    url: "UIServerEndPoint.asmx/ProcessRequest",
    urlAsync: "UIServerEndPoint.asmx/ProcessRequestAsync",
    type: "POST",
    contentType: "application/json; charset=utf-8",
    processData: true,
    dataType: "json",
    paramName: "request",
    async: true,
    xhr: function() {
      try {
        if (window.XMLHttpRequest != undefined)
          return new window.XMLHttpRequest();
        else return new window.ActiveXObject("Microsoft.XMLHTTP");
      } catch (e) {}
    }
  },
  // basic ajax request
  invoke: function (settings) {
    var retryAttempts = 0;  //counter for number of retries. 
    var retryTimeout = 1000; //time in ms to wait before retry
    var maxRequestRetries = runTimeOptions.maxRequestRetries != null ? runTimeOptions.maxRequestRetries : 0;

    var sendRequest = function () {
      // copy the default ajax settings
      iQuery.copy(iQuery.ajax.ajaxSettings, settings);
      var status;
      var data;
      var callbackContext = settings;
      // convert data if not already a string
      if (
        settings.data &&
        settings.processData &&
        typeof settings.data !== "string"
      ) {
        settings.data =
          "{" + settings.paramName + ":" + iQuery.serialize(settings.data) + "}";
      }
      var xhr = iQuery.ajax.ajaxSettings.xhr();
      if (settings.serverAsync)
        xhr.open(settings.type, settings.urlAsync, settings.async);
      else xhr.open(settings.type, settings.url, settings.async);
      xhr.setRequestHeader("Content-Type", settings.contentType);
      /* The callback function */
      xhr.onreadystatechange = function (isTimeout) {
        // The request was aborted
        if (!xhr || xhr.readyState === 0 || isTimeout === "abort") {
          if (settings.complete) {
            settings.complete(callbackContext, xhr, status);
          }
          // The transfer is complete and the data is available, or the request timed out
        } else if (xhr && (xhr.readyState === 4 || isTimeout === "timeout")) {
          status =
            isTimeout === "timeout"
              ? "timeout"
              : !iQuery.ajax._httpSuccess(xhr)
                ? "error"
                : settings.ifModified && iQuery.ajax._httpNotModified(xhr)
                  ? "notmodified"
                  : "success";
          if (status === "success") {
            // Watch for, and catch, XML document parse errors
            try {
              data = iQuery.ajax._httpData(xhr, settings.dataType);
            } catch (err) {
              status = "parsererror";
              errMsg = err;
            }
          }
          // Make sure that the request was successful or notmodified
          if (status === "success" || status === "notmodified") {
            if (settings.success) {
              settings.success(callbackContext, data, status, xhr);
            }
          } else {
            if (settings.failed) {
              if (xhr.status == 503 && (maxRequestRetries <= -1 || retryAttempts < maxRequestRetries)) {
                xhr.abort();
                retryRequest();
              } else {
                settings.failed(iQuery.ajax._httpData(xhr, "json"), xhr, status);
              }
            }
          }         
          // Fire the complete handlers
          if (settings.complete) {
            settings.complete(callbackContext, xhr, status);
          }
        }
      };
      xhr.send(
        settings.type === "POST" ||
          settings.type === "PUT" ||
          settings.type === "DELETE"
          ? settings.data
          : null
      );
    }

    var retryRequest = function () {
      if (maxRequestRetries <= -1 || retryAttempts < maxRequestRetries) {
        retryAttempts++;
        parent.instance.log("Waiting " + retryTimeout + "ms and retrying Ajax request.", "info");
        setTimeout(function () {
          parent.instance.log("Retrying Ajax Request. Retry attempt " + retryAttempts + ".", "info");
          parent.cblock.clearCookies();
          sendRequest();
        }, retryTimeout);
      };
    };

    sendRequest();
  },
  // Determines if an XMLHttpRequest was successful or not
  _httpSuccess: function(xhr) {
    try {
      // IE error sometimes returns 1223 when it should be 204 so treat it as success, see #1450
      return (
        (!xhr.status && location.protocol === "file:") ||
        // Opera returns 0 when status is 304
        (xhr.status >= 200 && xhr.status < 300) ||
        xhr.status === 304 ||
        xhr.status === 1223 ||
        xhr.status === 0
      );
    } catch (e) {}
    return false;
  },
  // Determines if an XMLHttpRequest returns NotModified
  _httpNotModified: function(xhr) {
    // Opera returns 0 when status is 304
    return xhr.status === 304 || xhr.status === 0;
  },
  _httpData: function(xhr, type) {
    var ct = xhr.getResponseHeader("content-type") || "",
      xml = type === "xml" || (!type && ct.indexOf("xml") >= 0),
      data = xml ? xhr.responseXML : xhr.responseText;
    if (xml && data.documentElement.nodeName === "parsererror") {
      throw "parsererror";
    }
    if (typeof data === "string") {
      // Get the JavaScript object, if JSON is used.
      if (type === "json" || (!type && ct.indexOf("json") >= 0)) {
        data = iQuery.deserialize(data);
      }
      //			// If the type is "script", eval it in global context
      //			} else if ( type === "script" || !type && ct.indexOf("javascript") >= 0 ) {
      //				jQuery.globalEval( data );
      //			}
    }
    return data;
  }
};
// TODO: turn into a class
function Action() {}
Action.prototype = {
  Name: null,
  Source: null,
  process: function() {
    alert("Process needs to be implemented for " + this.Name);
  }
};
///
/// Hansen8.EventMessage
///
// TODO: turn into a class
function EventMessage(name, source, vid, params) {
  this.MethodName = name;
  this.Parameters = params;
  this.Source = source;
  this.VID = vid;
}
EventMessage.prototype = {};
///
/// Hansen8.AppletEnvelope
///
// TODO: turn into a class
function AppletEnvelope(appid, mon) {
  this.AppletID = appid;
  this.Moniker = mon;
  this.AppletEvents = new Array();
}
AppletEnvelope.prototype = {};
///
/// Hansen8.SessionEnvelope
///
// TODO: turn into a class
function SessionEnvelope() {
  this.AppletEnvelopes = new Array();
  this.SessionEvents = new Array();
  this.Actions = new Array();
}
SessionEnvelope.prototype = {};
ResultAction.prototype = new Action();
ResultAction.prototype.constructor = ResultAction;
ResultAction.prototype = {
  process: function() {
    var title =
      this.Exception == undefined ? "Error" : this.Exception.ExceptionType;
    var stack = this.Exception == undefined ? "" : this.Exception.StackTrace;
    openErrorMsg(title, this.Description, "", "", "", "", "", "", "", this.VID);
  }
};
function ResultAction() {}
// Hansen8 specific functions
// TODO: turn into a class
iQuery.H8 = iQuery.prototype = {
  // available actions
  _actions: {
    ResultAction: ResultAction
  },
  // calls a Hansen8 method with the given params.  Invokes the 'success' callback function when successful and passing it
  // the action to perform
  // method:  H8 method to invoke
  // params:  parameters to pass into the 'method'.  THIS MUST BE AN ARRAY
  // control:  the control invoking this function
  // success:  callback function when the call returns
  // failed:  an optional callback function when the call fails
  // USAGE:
  // var params = new Array();
  // params.push("tes");
  // iQuery.H8.callApplet('getSuggestion', params, this, function(action) { action.process(this);});
  callApplet: function (method, params, control, success, failed, isMultiple) {
    var envelope = iQuery.H8.createEnvelope(
      control,
      method,
      params,
      isMultiple
    );
    if (envelope)
      iQuery.H8.callAppletWithContext(
        envelope,
        success,
        failed,
        method,
        control
      );
  },
  ///
  ///Call the Applet in an async manner. This requires a read only session for use
  ///
  callAppletAsync: function(
    method,
    params,
    control,
    success,
    failed,
    isMultiple
  ) {
    var envelope = iQuery.H8.createEnvelope(control, method, params);
    envelope.serverAsync = true;
    if (envelope)
      iQuery.H8.callAppletWithContext(
        envelope,
        success,
        failed,
        method,
        control
      );
  },
  //
  //Create the session envelope to send
  //
  createEnvelope: function(control, method, params, isMultiple) {
    if (!isMultiple) {
      var em = findEM(control, control.Vid);
      // Retrieve the moniker and appid
      if (em) {
        moniker = em.getAttribute("monk");
        appid = em.getAttribute("apid");
        var vid = control.getAttribute("Vid");
        return iQuery.H8._createSession(
          method,
          moniker,
          appid,
          control.id,
          vid,
          params
        );
      }
    } else {
      return iQuery.H8._createSessionApplets(
        method,
        control,
        control.id,
        control.vid,
        params
      );
    }
  },
  callAppletWithContext: function(envelope, success, failed, method, control) {
    var callingVid = control.Vid;
    var onSuccess = function _anonymous_H8Ajax_js_8(session) {
      if (success) {
        //Notify any success handlers that are expecting an action
        for (var key in session.Actions) {
          var action = session.Actions[key];
          if (
            action.Source.VID == callingVid &&
            action.Source.MethodName == method
          ) {
            var a = new iQuery.H8._actions[action.Name]();
            iQuery.copy(action, a);
            try {
              //Execute the return call.  if the page has closed we can't run the freed script
              success(a);
            } catch (e) {}
          }
        }
        //Notify any success handlers that are expecting user defined data
        for (var key in session.Results) {
          var result = session.Results[key];
          try {
            //Execute the return call.  if the page has closed we can't run the freed script
            success(result);
          } catch (e) {}
        }
      }
    };
    var onFailure = function _anonymous_H8Ajax_js_9(exception) {
      var res = new ResultAction();
      res.Description = exception.Message || exception.getAttribute("Message");
      res.Exception = exception;
      res.process();
    };
    iQuery.H8.callHansen8(
      null,
      envelope,
      onSuccess,
      failed ? failed : onFailure
    );
  },
  // calls Hansen8 and then callback the success function and passing it the action
  callHansen8: function(url, envelope, success, failed) {
    var onSuccess = function(callbackContext, response, status, xhr) {
      if (success) {
        success(response.d);
      }
    };
    var onFailure = function _anonymous_H8Ajax_js_12(failure, xhr, status) {
      if (failed) failed(failure);
    };
    iQuery.post(
      url,
      envelope,
      null,
      onSuccess,
      onFailure,
      envelope.serverAsync
    );
  },
  _createSession: function(method, moniker, appid, src, vid, params) {
    var session = new SessionEnvelope();
    var applet = new AppletEnvelope(appid, moniker);
    var appEvent = new EventMessage(method, src, vid, params);
    applet.AppletEvents.push(appEvent);
    session.AppletEnvelopes.push(applet);
    return session;
  },
  _createSessionApplets: function(method, applets, src, vid, params) {
    var session = new SessionEnvelope();
    var appEvent = new EventMessage(method, src, vid, params);
    var applet;
    for (var i = 0; i < applets.length; i++) {
      applet = new AppletEnvelope(applets[i].id, applets[i].moniker);
      applet.AppletEvents.push(appEvent);
      session.AppletEnvelopes.push(applet);
    }
    return session;
  }
};
